import { createContext, useState, useEffect } from "react";

import useAxios from "../../utils/useAxios";
import { resObj } from "../../utils/constants";

const FormulationPickerContext = createContext();

export default FormulationPickerContext;

export const FormulationPickerProvider = ({ children }) => {
  const api = useAxios();

  const [apiRes, setApiRes] = useState(resObj);
  const [formulationsObj, setFormulationsObj] = useState({
    type: 'Plate', ids: [],
  });
  const [formulationsArray, setFormulationsArray] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  useEffect(() => {
    getFormulations();
  }, [formulationsObj?.type]);

  const getFormulations = async () => {
    try {
      setApiRes({...apiRes, loading: true});
      const response = await api.get(
        '/api/materials-capture/formulations/data/get', {
          params: { formulation_type: formulationsObj?.type }
        }
      );
      
      if (response.status === 200) {
        setFormulationsArray(response.data);
        setApiRes({ ...apiRes, loading: false });
      }
    } catch (err){
      setApiRes({
        ...apiRes,
        axiosError: true,
        errMsg: JSON.stringify(err.response.data).replace(/[{}[\]"']/g, ''),
        errHeading: 'Formulations Data Get',
        loading: false,
      });
    }
  };

  const validate = () => {
    const errors = {};
    if (formulationsObj?.ids.length === 0) {
      errors['formulation'] = `${formulationsObj?.type} is required!`;
    }    
    return errors;
  };

  const contextData = {
    formulationsObj: formulationsObj,
    setFormulationsObj: setFormulationsObj,
    formulationsArray: formulationsArray,
    setFormulationsArray: setFormulationsArray,
    formErrors: formErrors,
    setFormulationFormErrors: setFormErrors,
    isSubmit: isSubmit,
    setIsSubmit: setIsSubmit,
    validate: validate,
  };

  return (
    <FormulationPickerContext.Provider value={contextData}>
      {children}
    </FormulationPickerContext.Provider>
  )
};